import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';

import { getAll as getClientPackages } from '~main/actions/clients/clientPackages';
import { selectClientPackages } from '~main/selectors/clients/clientPackages';

interface PackageNames {
  getPackageName: (extPackageId: number) => string | undefined;
}

/**
 * Resolves plan.package_id to a package name for the sidebar plan list.
 * package_id references TP1 tblClientPackages (the package definition), so
 * names come straight from the company-wide client packages lookup — package
 * schedules only link packages to clients and are not involved here.
 */
export const usePackageNames = (): PackageNames => {
  const dispatch = useAppDispatch();
  const packages = useAppSelector(selectClientPackages);

  useEffect(() => {
    dispatch(getClientPackages());
  }, [dispatch]);

  const namesById = useMemo(() => new Map(packages.map(({ id, name }) => [id, name])), [packages]);

  return { getPackageName: (extPackageId: number) => namesById.get(extPackageId) };
};
